.flag,
.icon {
  list-style: none;
  margin: 0;
  padding: 0;
}

.flag li,
.icon li {
  align-items: center;
  background-color: var(--color-background-secondary);
  border: 1px solid var(--color-neutral-400);
  display: inline-flex;
  flex-direction: column;
  font-size: var(--font-size-small);
  height: 100px;
  justify-content: space-around;
  list-style-type: none;
  margin: 4px 2px;
  padding: 4px;
  text-align: center;
  vertical-align: middle;
  width: 100px;
}
li.large {
  width: 218px;
}

.flag li {
  height: 140px;
}
